<template>
  <div>
    <div class="tabs is-medium">
      <ul>
        <li :class="isActive($options.DNS_RECORDS)">
          <router-link
            tag="a"
            :to="{ name: $options.DNS_RECORDS }"
          >
            {{ $t('domains.pages.dns_records') }}
          </router-link>
        </li>
        <li :class="isActive($options.NAMESERVERS)">
          <router-link
            tag="a"
            :to="{ name: $options.NAMESERVERS }"
          >
            {{ $t('domains.pages.nameservers') }}
          </router-link>
        </li>
        <li :class="isActive($options.DNS_SECURITY)">
          <router-link
            tag="a"
            :to="{ name: $options.DNS_SECURITY }"
          >
            {{ $t('domains.pages.dns_security') }}
          </router-link>
        </li>
      </ul>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {

  name: 'AdvancedSettings',
  created () {
    this.$options.DNS_RECORDS = 'DNSRecords'
    this.$options.NAMESERVERS = 'Nameservers'
    this.$options.DNS_SECURITY = 'DNSSecurity'
  },
  methods: {
    isActive (name) {
      const { $route } = this
      return { 'is-active': name === $route.name }
    }
  }
}
</script>
